import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { CaptionText, DropdownMenu } from '@paypalcorp/pp-react';
import get from 'lodash/get';
import { trackFieldChange, trackFieldClosed, trackFieldFocus } from '../../../lib/fpti';
import styles from '../Configurator.module.less';
import IntegrationPageSectionContext from '../StateManagement/IntegrationPageSectionContext';

const CardFieldsConfigurator = ({ ecmContent }) => {
  const availableCustomization = get(ecmContent, 'contentJson.CardStyle', []);
  const {
    cardFieldsConfigurator: { updateCardFieldStyles },
    cardFieldsConfigurator: { value: cardFieldsConfigurator }
  } = useContext(IntegrationPageSectionContext);

  function onValueChange(properties) {
    const { key, value } = properties;
    trackFieldChange(key, value);
    updateCardFieldStyles(properties);
  }
  return (
    <>
      {availableCustomization.map((stylingType, index) => {
        const { description, customizations, snippetReplacementKey } = stylingType;
        return (
          <div key={index} className={styles.card_field_customization}>
            <div className={styles.configuration}>
              <h4>{description}</h4>
              {customizations.map((field) => {
                const { name, options, key, targetProperty } = field;

                const value = get(cardFieldsConfigurator, [
                  snippetReplacementKey,
                  targetProperty,
                  key
                ]);
                return (
                  <div key={name} className={styles.configuration_item}>
                    <CaptionText className={styles.configuration_text}>{name}</CaptionText>
                    <DropdownMenu
                      label={name}
                      className={styles.configuration_dropdown}
                      options={options}
                      value={value}
                      onClick={() => trackFieldFocus(name)}
                      onChange={(e) =>
                        onValueChange({
                          snippetReplacementKey,
                          targetProperty,
                          key,
                          value: e.target.value
                        })
                      }
                      onClose={() => trackFieldClosed('Buyer Country')}
                    />
                  </div>
                );
              })}
            </div>
          </div>
        );
      })}
    </>
  );
};

CardFieldsConfigurator.propTypes = { ecmContent: PropTypes.object.isRequired };
export default CardFieldsConfigurator;
